import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "warehouse-form" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"960px"}
}
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = {
  class: "title",
  style: {"font-size":"22px"}
}
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"14px"}
}
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { class: "input-field" }
const _hoisted_9 = { class: "input-field" }
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = { class: "input-field" }
const _hoisted_12 = { class: "input-field" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "input-field" }
const _hoisted_16 = { class: "input-field" }
const _hoisted_17 = { class: "input-field" }
const _hoisted_18 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "xml-overlay"
}
const _hoisted_26 = { class: "xml-card" }
const _hoisted_27 = { class: "item-meta" }
const _hoisted_28 = { class: "actions" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "subtitle error-text"
}
const _hoisted_31 = {
  key: 1,
  class: "xml-list"
}
const _hoisted_32 = { class: "item-meta" }
const _hoisted_33 = { class: "actions" }
const _hoisted_34 = {
  key: 1,
  class: "xml-overlay"
}
const _hoisted_35 = { class: "xml-card" }
const _hoisted_36 = { class: "input-field" }
const _hoisted_37 = { class: "actions" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "subtitle error-text"
}
const _hoisted_40 = {
  key: 1,
  class: "xml-list"
}
const _hoisted_41 = { class: "item-meta" }
const _hoisted_42 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveItem && _ctx.saveItem(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.isEdit ? 'Editar ferramenta' : 'Adicionar ferramenta'), 1),
            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "subtitle" }, "Cadastro de itens no almoxarifado.", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-ghost",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openXmlModal && _ctx.openXmlModal(...args)))
            }, "Acrescentar nota em .xml"),
            _createElementVNode("button", {
              class: "btn btn-ghost",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDanfeModal && _ctx.openDanfeModal(...args)))
            }, "Escanear DANFE")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { for: "item-code" }, "ID unico", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-code",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemForm.code) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.itemForm.code]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { for: "item-name" }, "Nome / descricao", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-name",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemForm.name) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.itemForm.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { for: "item-category" }, "Categoria", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "item-category",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemForm.category) = $event))
            }, [...(_cache[39] || (_cache[39] = [
              _createElementVNode("option", { value: "ferramenta" }, "Ferramenta", -1),
              _createElementVNode("option", { value: "consumivel" }, "Consumivel", -1),
              _createElementVNode("option", { value: "outro" }, "Outro", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.itemForm.category]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { for: "item-quantity-total" }, "Quantidade total", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-quantity-total",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.itemForm.quantityTotal) = $event)),
              type: "number",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                _ctx.itemForm.quantityTotal,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { for: "item-quantity-min" }, "Quantidade minima", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-quantity-min",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemForm.quantityMin) = $event)),
              type: "number",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                _ctx.itemForm.quantityMin,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { for: "item-location" }, "Area (projeto em andamento)", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "item-location",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemForm.location) = $event))
            }, [
              _cache[43] || (_cache[43] = _createElementVNode("option", { value: "" }, "Sem area", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: project.id,
                  value: project.id
                }, _toDisplayString(project.name), 9, _hoisted_13))
              }), 128)),
              (_ctx.hasLegacyLocation)
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    value: _ctx.itemForm.location
                  }, _toDisplayString(_ctx.itemForm.location), 9, _hoisted_14))
                : _createCommentVNode("", true)
            ], 512), [
              [_vModelSelect, _ctx.itemForm.location]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[45] || (_cache[45] = _createElementVNode("label", { for: "item-condition" }, "Estado", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-condition",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.itemForm.conditionStatus) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.itemForm.conditionStatus]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { for: "item-unit-value" }, "Valor unitario", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "item-unit-value",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.itemForm.unitValue) = $event)),
              type: "number",
              min: "0",
              step: "0.01"
            }, null, 512), [
              [
                _vModelText,
                _ctx.itemForm.unitValue,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[47] || (_cache[47] = _createElementVNode("label", null, "Imagem do item", -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.isDragOver }]),
            onDragenter: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
            onDragover: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
            onDragleave: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.isDragOver = false), ["prevent"])),
            onDrop: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onImageDropped && _ctx.onImageDropped(...args)), ["prevent"]))
          }, [
            (_ctx.itemForm.photoDataUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: _ctx.$resolveUrl(_ctx.itemForm.photoDataUrl),
                    alt: "preview item"
                  }, null, 8, _hoisted_19),
                  _createElementVNode("button", {
                    class: "image-remove",
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removePhoto && _ctx.removePhoto(...args))),
                    "aria-label": "Remover foto"
                  }, "x")
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "image-add",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.triggerImageInput && _ctx.triggerImageInput(...args)))
                }, "+"))
          ], 34),
          _createElementVNode("input", {
            id: "warehouse-item-photo",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onPhotoSelected && _ctx.onPhotoSelected(...args)))
          }, null, 32)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            disabled: _ctx.saving
          }, _toDisplayString(_ctx.saving ? 'Salvando...' : (_ctx.isEdit ? 'Salvar edicao' : 'Adicionar ferramenta')), 9, _hoisted_22),
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetItemForm && _ctx.resetItemForm(...args)))
          }, "Limpar", 8, _hoisted_23),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, "Cancelar", 8, _hoisted_24)
        ])
      ], 32)
    ]),
    (_ctx.xmlModalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[49] || (_cache[49] = _createElementVNode("h3", null, "Acrescentar nota em .xml", -1)),
            _cache[50] || (_cache[50] = _createElementVNode("p", { class: "subtitle" }, "Envie o arquivo XML da nota para extrair os itens.", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["xml-dropzone", { 'is-drag-over': _ctx.isXmlDragOver }]),
              onDragenter: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.isXmlDragOver = true), ["prevent"])),
              onDragover: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.isXmlDragOver = true), ["prevent"])),
              onDragleave: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.isXmlDragOver = false), ["prevent"])),
              onDrop: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onXmlDropped && _ctx.onXmlDropped(...args)), ["prevent"]))
            }, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.triggerXmlInput && _ctx.triggerXmlInput(...args)))
              }, "Selecionar arquivo .xml"),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.xmlFileName || 'Nenhum arquivo selecionado'), 1)
            ], 34),
            _createElementVNode("input", {
              id: "xml-note-input",
              class: "hidden-input",
              type: "file",
              accept: ".xml,text/xml,application/xml",
              onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onXmlSelected && _ctx.onXmlSelected(...args)))
            }, null, 32),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                disabled: _ctx.xmlLoading,
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.parseXmlFile && _ctx.parseXmlFile(...args)))
              }, _toDisplayString(_ctx.xmlLoading ? 'Lendo arquivo...' : 'Ler XML'), 9, _hoisted_29),
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.closeXmlModal && _ctx.closeXmlModal(...args)))
              }, "Cancelar")
            ]),
            (_ctx.xmlError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.xmlError), 1))
              : _createCommentVNode("", true),
            (_ctx.xmlItems.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _cache[48] || (_cache[48] = _createElementVNode("h4", null, "Itens encontrados no XML", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xmlItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${item.description}-${index}`,
                      class: "xml-item"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(item.description), 1),
                        _createElementVNode("div", _hoisted_32, "Quantidade: " + _toDisplayString(item.quantity), 1)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveXmlItemsToStock && _ctx.saveXmlItemsToStock(...args)))
                    }, " Salvar "),
                    _createElementVNode("button", {
                      class: "btn btn-ghost",
                      type: "button",
                      onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeXmlModal && _ctx.closeXmlModal(...args)))
                    }, "Cancelar")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.danfeModalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Escanear DANFE", -1)),
            _cache[53] || (_cache[53] = _createElementVNode("p", { class: "subtitle" }, "Informe a chave/codigo de barras para consultar a API MeuDanfe.", -1)),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.danfeBarcode) = $event)),
                type: "text",
                placeholder: "Chave de acesso (44 digitos)",
                onKeyup: _cache[31] || (_cache[31] = _withKeys(
//@ts-ignore
(...args) => (_ctx.lookupDanfe && _ctx.lookupDanfe(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.danfeBarcode]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                disabled: _ctx.danfeLoading,
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.lookupDanfe && _ctx.lookupDanfe(...args)))
              }, _toDisplayString(_ctx.danfeLoading ? 'Consultando...' : 'Solicitar'), 9, _hoisted_38),
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.closeDanfeModal && _ctx.closeDanfeModal(...args)))
              }, "Cancelar")
            ]),
            (_ctx.danfeError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.danfeError), 1))
              : _createCommentVNode("", true),
            (_ctx.danfeItems.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _cache[51] || (_cache[51] = _createElementVNode("h4", null, "Itens encontrados na DANFE", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.danfeItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `danfe-${item.description}-${index}`,
                      class: "xml-item"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(item.description), 1),
                        _createElementVNode("div", _hoisted_41, "Quantidade: " + _toDisplayString(item.quantity), 1)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.saveDanfeItemsToStock && _ctx.saveDanfeItemsToStock(...args)))
                    }, "Salvar"),
                    _createElementVNode("button", {
                      class: "btn btn-ghost",
                      type: "button",
                      onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeDanfeModal && _ctx.closeDanfeModal(...args)))
                    }, "Cancelar")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}